const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteAulaIdProjecte = async (id_aula: string, id_projecte: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/projectes/${id_projecte}`, {
            method: 'DELETE',
        });
        if (response.ok) {
            return true;
        } else {
            console.error(await response.text());
            return false;
        }
    } catch (error) {
        console.error('Error al delete:', error);
        return false;
    }
};
